/** VAT report inner side panel — needs a wide viewport to show beside the grid. */
export const RESPONSIVE_PANEL_WIDTH_BREAKPOINT = 1500;
export const RESPONSIVE_PANEL_HEIGHT_BREAKPOINT = 750;

export const isResponsivePanelWideLayout = (
  width: number,
  height: number
): boolean =>
  width > RESPONSIVE_PANEL_WIDTH_BREAKPOINT &&
  height > RESPONSIVE_PANEL_HEIGHT_BREAKPOINT;

/**
 * App chrome sidebar (SidePanel collapse toggle).
 * Keep the original width-only threshold so the open/close arrow stays available
 * on typical laptop sizes; do not reuse the VAT report 1500×750 gate.
 */
export const APP_SIDEBAR_WIDE_WIDTH_BREAKPOINT = 1024;

export const canUseAppSidebarWideLayout = (width: number): boolean =>
  width > APP_SIDEBAR_WIDE_WIDTH_BREAKPOINT;
